import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { authError, loadCorporateSession } from "../../utils/auth-session";
import ElevvaLoader from "../ui/ElevvaLoader/ElevvaLoader";
import MobileButton from "../Mobile/Buttons/MobileButton";

export default function CorporateSessionGuard({ children }) {
    const [ready, setReady] = useState(false);
    const [error, setError] = useState("");
    const [attempt, setAttempt] = useState(0);
    useEffect(() => {
        let active = true;
        setError("");
        if (localStorage.getItem("my_code")) loadCorporateSession().then(() => {
            if (active) setReady(true);
        }).catch(err => { if (active) setError(authError(err)); });
        return () => { active = false; };
    }, [attempt]);
    if (!localStorage.getItem("my_code")) return <Navigate to="/" replace />;
    if (ready) return children;
    if (!error) return <ElevvaLoader variant="page" label="Cargando tu perfil…" detail="Preparando tu espacio de trabajo" />;
    return <div className="p-4 text-center" role="alert"><p>{error}</p><MobileButton text="Reintentar cargar perfil" onClick={() => setAttempt(value => value + 1)} /></div>;
}
